import { months } from '../constants'

// TODO convert to dayjs for consistency

export const formatStartDate = (date: Date) => `${months[date.getMonth()]} ${date.getFullYear()}`

export const formatValidThroughDate = (date: Date) =>
  `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
